import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Row, Select, Table } from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import commissionApi from "../../../../apis/Commission.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const BrandMonth = ({
  targetYear,
  setTargetYear,
  targetMonth,
  setTargetMonth,
  setNavType,
  selectBrand,
  brandMonth,
  getUserOrderList,
}) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const columns = [
    {
      title: "정산 월",
      dataIndex: "settlement_month",
      key: "settlement_month",
      width: 100,
      align: "center",
      render: (value) => {
        return (
          <span
            style={{
              color: "#117ffa",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => {
              setTargetYear(targetYear);
              setTargetMonth(moment(value).format("MM"));
              setNavType("case");
            }}
          >
            {moment(value).format("MM")}월
          </span>
        );
      },
    },
    {
      title: "정산 완료일",
      dataIndex: "settlement_complete_date",
      key: "settlement_complete_date",
      align: "center",
      render: (value, record) => {
        if (value) {
          return (
            <p className={`${record?.commission_status ? "" : "blue"}`}>
              {moment(value).format("YYYY.MM.DD")}
            </p>
          );
        } else {
          return (
            <p>
              {moment(`${targetYear}.${targetMonth}.15`)
                .add(1, "month")
                .format("YYYY.MM.DD")}
            </p>
          );
        }
      },
    },
    {
      title: "정산 금액",
      dataIndex: "expected_payment_amount",
      key: "expected_payment_amount",
      align: "center",
      render: (value, record) => {
        if (value) {
          return (
            <p className={`${record?.commission_status ? "" : "blue"}`}>
              {value.toLocaleString()}
            </p>
          );
        } else return 0;
      },
    },
    {
      title: "판매 금액",
      dataIndex: "total_purchase_amount",
      key: "total_purchase_amount",
      align: "center",
      render: (value, record) => {
        if (value) {
          return <p>{value.toLocaleString()}</p>;
        } else return 0;
      },
    },
    {
      title: "수수료 합계",
      dataIndex: "profit_amount",
      key: "profit_amount",
      align: "center",
      render: (value, record) => {
        if (value) {
          return (
            <p className={`${record?.commission_status ? "" : "red"}`}>
              -{value.toLocaleString()}
            </p>
          );
        } else return 0;
      },
    },
    {
      title: "당영 관리 수수료",
      dataIndex: "dy_manage_fee",
      key: "dy_manage_fee",
      align: "center",
      render: (value, record) => {
        if (value) {
          return <p>-{value.toLocaleString()}</p>;
        } else return 0;
      },
    },
    {
      title: "매출 연동 수수료",
      dataIndex: "sales_fee",
      key: "sales_fee",
      align: "center",
      render: (value, record) => {
        if (value) {
          return <p>-{value.toLocaleString()}</p>;
        } else return 0;
      },
    },
    // {
    //     title: '배송 관리 수수료',
    //     dataIndex: 'delivery_manage_fee',
    //     key: 'delivery_manage_fee',
    //     align: "center",
    //     render: (value, record) => {
    //         if (value) {
    //             return (
    //                 <p>
    //                     -{value.toLocaleString()}
    //                 </p>
    //             )
    //         } else return 0
    //     }
    // },
    {
      title: "정산 상태",
      dataIndex: "settlement_status",
      key: "settlement_status",
      align: "center",
      render: (value, record) => {
        let userType = user?.role === "super_admin";
        let target_confirm = record.target_confirm;
        // step 1) 당영은 데이터 보여주고, 브랜드는 데이터 가리기 - 정산 확정 후 value = 1;
        if (value === 0) {
          if (userType) {
            return (
              <Button
                className={`commission-button blue`}
                onClick={() => reportsFirst(record)}
                loading={isLoading}
              >
                {`정산요청`}
              </Button>
            );
          } else {
            return <p style={{ color: "#adb5bd" }}>정산예정</p>;
          }
        }
        // step 2) 브랜드 정산 확인 -> 이전에는 당영에서 정산확인중(대기)
        else if (value === 1) {
          // 브랜드 확인 대기 중
          if (!target_confirm) {
            return (
              <Button
                className={`commission-button ${userType ? "gray" : "blue"}`}
                loading={isLoading}
                onClick={() => {
                  if (!userType) {
                    reportsSecond(record);
                  }
                }}
              >
                {`${userType ? "정산확인 대기중" : "정산확인"}`}
              </Button>
            );
          }
        }
        // step 3) 당영 정산 확인 -> 이전에는 브랜드에서 정산확인중(대기)
        else if (value === 2) {
          return (
            <Button
              className={`commission-button ${userType ? "blue" : "gray"}`}
              loading={isLoading}
              onClick={() => {
                if (userType) {
                  reportsThird(record);
                }
              }}
            >
              {`${userType ? "정산확정" : "정산확정 대기중"}`}
            </Button>
          );
        }
        // step 4) 정산 확정 완료
        else if (value === 3) {
          return (
            <Button className={`commission-button gray`} disabled={true}>
              {`확정완료`}
            </Button>
          );
        } else {
          return <p style={{ color: "#adb5bd" }}>정산예정</p>;
        }
      },
    },
    user?.role === "super_admin" && {
      title: "정산 취소",
      dataIndex: "settlement_status",
      key: "settlement_status",
      align: "center",
      width: 120,
      render: (value, record) => {
        let userType = user?.role === "super_admin";
        if (userType) {
          if (value === 1) {
            return (
              <Button
                className={`commission-button blue`}
                onClick={() => reportsCancel(record)}
                loading={isLoading}
              >
                {`정산취소`}
              </Button>
            );
          } else {
            if (value !== 0) {
              return (
                <Button className={`commission-button gray`} disabled={true}>
                  {`취소불가`}
                </Button>
              );
            } else return "-";
          }
        }
      },
    },
  ].filter((item) => item);

  const handleMonth = (value) => {
    // let list = [...noticeList];
    // list[0].data = value + "월";
    // setNoticeList([...list]);
    setTargetMonth(value);
  };

  /**
   * step 1) 정산요청버튼 -> 당영관리자
   * 정산 요청 버튼 클릭
   * @returns {Promise<void>}
   */
  const reportsFirst = async (record) => {
    setIsLoading(true);
    try {
      if (
        window.confirm(
          `${moment(record.settlement_month).format(
            "YYYY년 M월",
          )} 내역의 정산요청을 진행하시겠습니까?`,
        )
      ) {
        let param = {
          settlement_type: 0,
          settlement_month: record.settlement_month,
          total_purchase_amount: record.total_purchase_amount,
          profit_amount: record.profit_amount,
          // withholding_tax: 0,
          dy_manage_fee: record.dy_manage_fee,
          sales_fee: record.sales_fee,
          expected_payment_amount: record.expected_payment_amount,
          created_by: user.id === 724 ? 1 : user.id,
          // target_id: selectBrand.id
          target_id: record.brand_id,
        };
        const res = await commissionApi.postReportsFirst(param);
        if (res.code === 200) {
          alert(
            `${moment(record.settlement_month).format(
              "YYYY년 M월",
            )} 내역이 정산이 요청되었습니다.`,
          );
          getUserOrderList();
        } else {
          throw res.msg;
        }
      }
    } catch (e) {
      alert(e);
    }
    setIsLoading(false);
  };

  /**
   * step 2) 정산확인버튼 -> 브랜드
   * @param record
   * @returns {Promise<void>}
   */
  const reportsSecond = async (record) => {
    setIsLoading(true);
    try {
      if (
        window.confirm(
          `${moment(record.settlement_month).format(
            "YYYY년 M월",
          )} 내역의 정산확인을 진행하시겠습니까?`,
        )
      ) {
        let param = {
          id: record.id,
          created_by: user.id,
        };
        const res = await commissionApi.postReportsSecond(param);
        if (res.code === 200) {
          alert(
            `${moment(record.settlement_month).format(
              "YYYY년 M월",
            )} 내역이 정산 확인되었습니다.`,
          );
          getUserOrderList();
        } else {
          throw res.msg;
        }
      }
    } catch (e) {
      alert(e);
    }
    setIsLoading(false);
  };

  /**
   * step 3) 정산확정버튼 -> 당영
   * @param record
   * @returns {Promise<void>}
   */
  const reportsThird = async (record) => {
    setIsLoading(true);
    try {
      if (
        window.confirm(
          `${moment(record.settlement_month).format(
            "YYYY년 M월",
          )} 내역의 정산확정을 진행하시겠습니까?`,
        )
      ) {
        let param = {
          id: record.id,
          settlement_type: record.settlement_type,
          settlement_month: record.settlement_month,
          brand_id: record.brand_id,
          created_by: user.id === 724 ? 1 : user.id,
        };
        const res = await commissionApi.postReportsThird(param);
        if (res.code === 200) {
          alert(
            `${moment(record.settlement_month).format(
              "YYYY년 M월",
            )} 내역이 정산 확정되었습니다.`,
          );
          getUserOrderList();
        } else {
          throw res.msg;
        }
      }
    } catch (e) {
      alert(e);
    }
    setIsLoading(false);
  };

  /**
   * 정산 취소
   * @param record
   * @returns {Promise<void>}
   */
  const reportsCancel = async (record) => {
    setIsLoading(true);
    try {
      if (
        window.confirm(
          `${"[" + selectBrand?.brand_name + "]"} ${moment(
            record.settlement_month,
          ).format("YYYY년 M월")} 내역의 정산을 취소하시겠습니까?`,
        )
      ) {
        let param = {
          settlementId: record.id,
          userId: user.id === 724 ? 1 : user.id,
        };
        const res = await commissionApi.deleteSettlement(param);
        if (res.code === 200) {
          alert(
            `${moment(record.settlement_month).format(
              "YYYY년 M월",
            )} 내역이 취소되었습니다.`,
          );
          getUserOrderList();
        } else {
          throw res.msg;
        }
      }
    } catch (e) {
      alert(e);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Row
        className="product-register-border-box"
        justify={"space-between"}
        wrap={false}
        style={{ marginTop: 20, borderBottom: 0 }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <span className="product-register-box-title">정산내역 및 목록</span>
          <p style={{ margin: 0, fontSize: "0.8rem", color: "#117ffa" }}>
            구매확정(배송완료일로부터 7일 후)을 기준으로 정산기준일 +1영업일째
            되는 날 정산 된 내역만 표기되어 매출액과 상이할 수 있습니다.
          </p>
        </div>
      </Row>
      <div
        className="product-register-border-box"
        style={{ padding: "20px 25px 40px", height: "fit-content" }}
      >
        <div className={`commission-year-select`}>
          <p>정산년도</p>
          <Select
            value={targetYear}
            onChange={(value, option) => {
              setTargetYear(value);
            }}
            style={{ width: 150, textAlign: "left" }}
            placeholder={"정산 년도"}
          >
            {["2022", "2023", "2024"]?.map((item) => (
              <Option key={item} value={item}>
                {item}
              </Option>
            ))}
          </Select>
          <Select
            value={targetMonth}
            onChange={(value, option) => {
              handleMonth(value);
            }}
            style={{ width: 150, textAlign: "left" }}
            placeholder={"정산 월도"}
          >
            {Array.from({ length: 12 })?.map((item, idx) => (
              <Option
                key={`year ${idx + 1}`}
                value={idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}
              >
                {idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}
              </Option>
            ))}
          </Select>
        </div>
        <Table
          className={`commission-table`}
          // rowSelection={rowSelection}
          columns={columns}
          // dataSource={commissionList}
          dataSource={brandMonth}
          loading={isLoading}
          bordered
          size="small"
          rowKey="month"
          rowClassName="coupon-table-row"
          // scroll={{x: 'calc(700px + 50%)'}}
          // onChange={tableOnChange}
          pagination={false}
        />
      </div>
    </>
  );
};
export default BrandMonth;
